<template>
  <div>
    <v-dialog persistent v-model="dialog_bulk_mark" max-width="80%">
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0">New Mark</span>
        </div>
        <v-card-text class="card-padding">
          <v-container class="px-0">
            <v-form ref="frm">
              <v-card v-for="(row, i) in editedItem.bulk.length" v-bind:key="i">
                <v-divider class="my-3"></v-divider>
                <v-row>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1"
                      >Mark</label
                    >
                    <v-text-field
                      v-model="editedItem.bulk[i].mark_name"
                      hide-details="auto"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                        mt-2
                      "
                      :rules="[(v) => !!v || 'Mark Name is required']"
                      dense
                      flat
                      filled
                      solo
                      height="46"
                      placeholder="Mark Name"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1"
                      >Mark Code</label
                    >
                    <v-text-field
                      v-model="editedItem.bulk[i].mark_code"
                      @keyup="capitalize(i)"
                      hide-details="auto"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                        mt-2
                      "
                      :rules="[(v) => !!v || 'Mark Code is required']"
                      dense
                      flat
                      filled
                      solo
                      height="46"
                      placeholder="Mark Code"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1">
                      Quality</label
                    >
                    <v-text-field
                      v-model="editedItem.bulk[i].mark_quality"
                      hide-details="auto"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        input-icon
                        mt-2
                      "
                      dense
                      flat
                      filled
                      solo
                      height="46"
                      placeholder="Quality"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1">
                      Mark Type</label
                    >
                    <v-select
                      v-model="editedItem.bulk[i].mark_type"
                      :items="markType"
                      item-text="name"
                      item-value="name"
                      color="rgba(0,0,0,.6)"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        border-radius-md
                        select-style
                        mt-2
                        mb-0
                        placeholder-light
                      "
                      :rules="[(v) => !!v || 'Mark is is required']"
                      placeholder="Mark type"
                      dense
                      flat
                      solo
                      outlined
                      single-line
                      height="46"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1">
                      District</label
                    >
                    <v-select
                      v-model="editedItem.bulk[i].district"
                      :items="districts"
                      return-object
                      item-text="district_name"
                      item-value="id"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        border-radius-md
                        select-style
                        mt-2
                        mb-0
                        placeholder-light
                      "
                      placeholder="District"
                      dense
                      flat
                      solo
                      outlined
                      single-line
                      height="46"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1">
                      Certificate</label
                    >
                    <v-select
                      v-model="editedItem.bulk[i].certificate"
                      :items="certificates"
                      return-object
                      item-text="certificate_name"
                      item-value="id"
                      color="rgba(0,0,0,.6)"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        border-radius-md
                        select-style
                        mt-2
                        mb-0
                        placeholder-light
                      "
                      placeholder="Certificate"
                      dense
                      flat
                      solo
                      outlined
                      single-line
                      height="46"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="3" sm="12" md="3" xs="12" lg="3">
                    <label class="text-md text-typo font-weight-bolder ms-1">
                      Auction Center</label
                    >
                    <v-select
                      v-model="editedItem.bulk[i].auction_center"
                      :items="auctionCenters"
                      return-object
                      item-text="auction_center_name"
                      item-value="id"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                        select-style
                        mt-3
                      "
                      outlined
                      chips
                      multiple
                      single-line
                      height="46"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                          label
                          color="bg-default"
                          class="py-1 px-2 my-0"
                          v-if="index === 0"
                        >
                          <span class="text-white text-caption ls-0">{{
                            item.auction_center_name
                          }}</span>
                        </v-chip>
                        <span
                          v-if="index === 1"
                          class="grey--text text-caption"
                        >
                          (+{{ editedItem.bulk[i].auction_center.length - 1 }}
                          others)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    cols="3"
                    sm="12"
                    md="3"
                    class="pa-1"
                    align-self="center"
                  >
                    <span class="pa-0" align-self="center">
                      <v-btn
                        class="mx-1 input-style"
                        outlined
                        small
                        color="red"
                        @click="remove(i)"
                        v-show="i || (!i && editedItem.bulk.length > 1)"
                        >Remove
                      </v-btn>
                    </span>
                    <span class="pa-0" align-self="center">
                      <v-btn
                        class="mx-1"
                        outlined
                        small
                        color="green"
                        @click="add()"
                        v-show="i == editedItem.bulk.length - 1"
                        >Add
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="cancel"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            >Cancel</v-btn
          >

          <v-btn
            @click="save"
            elevation="0"
            :ripple="false"
            height="43"
            dark
            class="text-capitalize btn-ls btn-primary bg-success py-3 px-6"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import axios from "axios";
import api from "../api";

export default {
  props: {
    input_data: Array,
    dialog_bulk_mark: Boolean,
  },
  name: "MarkBulk",
  data() {
    return {
      editedItem: {
        bulk: [
          {
            mark_name: "",
            mark_code: "",
            mark_quality: 0,
            district: null,
            certificate: null,
            auction_center: [],
            markType: this.markType,
          },
        ],
      },
      defaultItem: {
        bulk: [
          {
            mark_name: "",
            mark_code: "",
            mark_quality: 0,
            district: null,
            certificate: null,
            auction_center: [],
            markType: this.markType,
          },
        ],
      },
      districts: [],
      certificates: [],
      auctionCenters: [],
      markType: [
        {
          name: "Bought Leaf",
        },
        {
          name: "Estate",
        },
      ],
      headers: [
        {
          text: "Mark Name",
          align: "center",
          sortable: true,
          value: "mark_name",
        },
        {
          text: "Mark Code",
          align: "center",
          sortable: true,
          value: "mark_code",
        },
        {
          text: "Mark Quality",
          align: "center",
          sortable: true,
          value: "mark_quality",
        },
        {
          text: "Mark Type",
          align: "center",
          sortable: true,
          value: "mark_type",
        },
        {
          text: "Auction Center",
          value: "center",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.districts = await api.getDistrict();
      this.certificates = await api.getCertificate();
      this.auctionCenters = await api.getAuctionCenter();

      if (
        this.input_data &&
        this.input_data?.length > 0 &&
        this.input_data != undefined &&
        this.input_data != null
      ) {
        this.editedItem.bulk = this.input_data;
      }
    },

    validate() {
      return this.$refs.frm.validate();
    },
    reset() {
      return this.$refs.frm.reset();
    },
    cancel() {
      this.$emit("cancel_upload");
    },
    add() {
      this.editedItem.bulk.push({
        mark_name: "",
        mark_code: "",
        mark_quality: 0,
        district: null,
        certificate: null,
        auction_center: [],
        markType: this.markType,
      });
    },

    remove(index) {
      this.editedItem.bulk.splice(index, 1);
    },
    showSuccessAlert(message) {
      this.$swal({
        title: "Success",
        text: message,
        type: "success",
        timer: 3000,
        icon: "success",
      });
    },

    showErrorAlert(message) {
      this.$swal({
        title: "Error",
        text: message,
        type: "error",
        showConfirmButton: true,
        icon: "error",
      });
    },

    close() {
      this.editedItem.bulk = [];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.reset();
        this.$emit("close_dialog_bulk_mark");
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    capitalize(i) {
      this.editedItem.bulk[i].mark_code = this.editedItem.bulk[i].mark_code
        .toUpperCase()
     

      // this.editedItem.bulk[i].mark_code =
      //   this.editedItem.bulk[i].mark_code.toUpperCase();

      this.editedItem.bulk[i].mark_code =
        this.editedItem.bulk[i].mark_code.toUpperCase();
    },
    async save() {
      if (this.validate()) {
        try {
          let type = "Saved";
          await api.createBulk(this.editedItem);
          this.showSuccessAlert(`Marks ${type}.`);
          this.close();
        } catch (err) {
          this.showErrorAlert(err.message);
        }
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>
